<template>
	<section class="hero">
		<div class="hero__container">
			<div class="hero__main-gradient"></div>
			<div class="hero__gradient"></div>
			<div class="hero__container-inner">
				<!-- <GlobalImage class="hero__image" src="homepage-hero2-v2.webp" loading="eager" fetchpriority="high" :lazyLoad="false" :height="1160" />
			<GlobalImage
				class="hero__image-mobile"
				src="homepage-hero2-mobile-v2.webp"
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				:height="485" /> -->
				<h1 class="hero__title">{{ $t('modules.home_page_module.home_page_hero.start_journey') }}</h1>
				<!-- <GlobalImage
				class="hero__image hero__image--mask"
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				src="homepage-hero-mask-v2.png"
				:height="1160" />
			<GlobalImage
				class="hero__image hero__image--mask-big"
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				src="homepage-hero-mask-big-v3.png"
				:height="1160" />
			<GlobalImage
				class="hero__image-mobile hero__image-mobile--mask"
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				src="homepage-hero-mobile-mask-v2.png"
				:height="265" /> -->
				<div ref="bookerContainerRef" class="hero__booker-container">
					<h2 class="hero__subtitle">{{ $t('modules.home_page_module.home_page_hero.car_rental') }}</h2>
					<div class="hero__days-months-google-container">
						<GlobalBookerDaysMonths />
						<GlobalBookerGoogleReviews />
					</div>
					<div class="hero__global-booker-wrapper" :style="{ minHeight: bookerHeight ? `${bookerHeight}px !important` : 'unset' }">
						<GlobalBooker v-if="!isNavBookerVisible || top > 100" />
					</div>
				</div>
				<span :key="reloadAdvantages">
					<GlobalBookerAdvantages v-if="isMobile_lg" />
					<GlobalBookerAdvantages v-else />
				</span>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
const bookerTarget = inject<HTMLElement>('bookerTarget')
const { top } = useElementBounding(bookerTarget)
const isNavBookerVisible = inject<Ref<boolean>>('isNavBookerVisible')
const { isMobile_lg } = useWindowWidth()
const bookerHeight = ref()
const reloadAdvantages = ref(0)

const assignBookerWrapperHeight = () => {
	if (bookerHeight.value) return

	const globalBooker = document.querySelector('.hero__global-booker-wrapper')
	if (globalBooker) {
		bookerHeight.value = globalBooker.clientHeight
	}
}
const bookerContainerRef = ref<HTMLElement | null>(null)

onMounted(() => {
	window.addEventListener('scroll', assignBookerWrapperHeight)
	reloadAdvantages.value++

	setTimeout(() => {
		if (bookerContainerRef.value) {
			bookerContainerRef.value.style.transform = 'none'
		}
	}, 250)
})
onBeforeUnmount(() => {
	try {
		window.removeEventListener('scroll', assignBookerWrapperHeight)
	} catch (error) {
		console.error(error)
	}
})
</script>

<style scoped lang="scss">
@import './HomePageHero.scss';
</style>
